export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mb-4">
            关于皮皮漫画
          </h2>
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
            皮皮漫画网成立于2020年，是国内领先的日韩与国漫精品推荐平台。我们致力于为漫画爱好者提供全面、快速、高品质的阅读体验，覆盖韩漫推荐、日漫系列、国漫大图三大核心品类。从热门排行到冷门佳作，从实时更新到深度专题，皮皮漫画始终以读者为中心，用心打造每一个漫画爱好者的精神角落。未来，我们将持续优化产品体验，拓展内容资源，让更多人享受漫画带来的快乐与感动。
          </p>
        </div>
      </div>
    </section>
  );
}